window.$ = window.jQuery = require('jquery')
window.Popper = require('popper.js');

window.axios = require('axios')
window.axios.defaults.headers.common = {
	'X-CSRF-TOKEN': window.Laravel.csrfToken,
	'X-Requested-With': 'XMLHttpRequest'
}